import { initializeApp, getApps, getApp } from "firebase/app";
import { getFirestore, doc, getDoc, setDoc, serverTimestamp } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

// Guarded init so this and MapEngine's init share ONE Firebase app (no duplicate-app error).
const app = getApps().length ? getApp() : initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const storage = getStorage(app);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();

// Bootstrap managers: these emails become 'manager' on first sign-in.
export const MANAGER_EMAILS = ["paik@ashonair.com"];

// Assignable roles (extend this list to add more, e.g. 'dispatcher').
export const ROLES = ["collector", "telemarketing", "manager"];

// Manager "creates an account" by pre-authorizing an email + role BEFORE the person signs
// in. When they sign in, they get that role immediately (no pending step).
export async function preauthorizeEmail(email, role) {
  const e = (email || "").trim().toLowerCase();
  if (!e) return;
  await setDoc(doc(db, "allowlist", e), { email: e, role, invitedAt: serverTimestamp() }, { merge: true });
}

// Ensure a users/{uid} record exists and return the user's role. New sign-in: bootstrap
// managers -> 'manager', else the pre-authorized role from the allowlist, else 'pending'.
export async function ensureUserRecord(user) {
  const ref = doc(db, "users", user.uid);
  const snap = await getDoc(ref);
  const email = (user.email || "").toLowerCase();
  if (snap.exists()) {
    const data = snap.data();
    await setDoc(ref, { name: user.displayName || data.name || "", email, lastLogin: serverTimestamp() }, { merge: true });
    return data.role || "pending";
  }
  let role = "pending";
  if (MANAGER_EMAILS.includes(email)) role = "manager";
  else { try { const al = await getDoc(doc(db, "allowlist", email)); if (al.exists() && al.data().role) role = al.data().role; } catch (e) {} }
  await setDoc(ref, { name: user.displayName || "", email, role, createdAt: serverTimestamp(), lastLogin: serverTimestamp() }, { merge: true });
  return role;
}
